import React, { useState } from "react";
import { useIsMobile } from "../../hooks/responsive";
import { Box, styled, Typography } from "@mui/material";
import { CenteredSiteBlock } from "../../routes/Home";
import { ReactComponent as StayInformedImage } from "../../resources/images/svg/home/stayInformed.svg";
import InexButton from "../InexButton";

const Container = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    minHeight: "100px",
    backgroundColor: theme.palette.blackPro,
    position: "relative",
  };
});

const StayInformed = () => {
  const isMobile = useIsMobile();

  const [email, setEmail] = useState("");
  const [error, setError] = useState({
    status: false,
    message: "",
  });

  const handleChangeEmail = (value) => {
    setError({ status: false });
    setEmail(value);
  };

  const checkEmail = (val) => {
    const reg = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return reg.test(val);
  };

  const onNewsletterFormSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (email === "") {
      setError({
        status: true,
        message: "Veuillez renseigner votre adresse email",
      });
    } else {
      const isEmailValid = checkEmail(email);
      if (!isEmailValid) {
        setError({
          status: true,
          message: "Veuillez renseigner une adresse email valide",
        });
      } else {
        window.location.href = `https://login.inexplore.com/newsletter?email=${email}&actifPro=1&referrer=${window.location.href}`;
        setEmail("");
      }
    }
  };


  return (
    <Container className={"develop-alliances"}>
      <CenteredSiteBlock
        sx={{
          position: "relative",
          backgroundRepeat: "no-repeat",
          backgroundSize: "stretch",
          backgroundPosition: "top",
          marginTop: (theme) => theme.spacing(isMobile ? 5 : 10),
          marginBottom: (theme) => theme.spacing(isMobile ? 5 : 10),
          display: "flex",
          flexDirection: "column",
          paddingLeft: "20px",
          paddingRight: "20px",
        }}
      >
        <Typography
          variant={"h2"}
          sx={{
            textAlign: "center",
            color: "white",
            marginBottom: -10,
          }}
        >
           Pas encore prêt(e) à vous abonner ?
        </Typography>

        <StayInformedImage
          style={{
            width: "100%",
          }}
        />

        <form
          className={
            !error.status ? "form" : "form input-border-error-newsletter-footer"
          }
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "10px" : "20px",
            alignItems: "center",
            width: isMobile ? "80%" : "50%",
            marginTop: "-60px",
          }}
        >
          <input
            type="email"
            placeholder="Votre adresse email"
            value={email}
            onChange={(e) => handleChangeEmail(e.target.value)}
            style={{
              paddingLeft: "20px",
              borderColor: "white",
              height: "50px",
              minHeight: "50px",
              width: "100%",
              fontFamily: "Branding SemiBold",
              fontSize: "1em",
              outline: "none",
              boxShadow: "none",
              border: "none",
              borderRadius: "30px",
            }}
          />
          <InexButton
            text={"Je m'inscris"}
            variant={"text"}
            textWithGradient={false}
            onClick={(e) => onNewsletterFormSubmit(e)}
            sx={{
              zIndex: 1,
              p: 3,
              width: isMobile ? "100%" : "175px",
              height: "50px",
              background: (theme) => theme.palette.primary.main,
              border: (theme) => theme.palette.primary.main + " solid 3px",
              color: "white",
              "&:hover": {
                backgroundColor: "white",
                "& > p": {
                  color: (theme) => theme.palette.primary.main,
                },
              },
            }}
          />
        </form>
      </CenteredSiteBlock>
    </Container>
  );
};

export default StayInformed;
